import authMachine, { AuthStates, AuthEventType } from "./authMachine";
const AuthMachine = {};
AuthMachine.machine = authMachine;
AuthMachine.state = AuthStates;
AuthMachine.eventType = AuthEventType;
export default AuthMachine;